(function(){

    var isScriptLoaded = false;
    function isRenderReady(callback){
        if(isScriptLoaded)callback();
        var script = document.createElement("script")
        script.type = "text/javascript";
        script.onload = function(){
            isScriptLoaded = true;
            callback();
        };
        script.src = "https://cdn.jsdelivr.net/npm/ibp-max@latest/plugin/lottieanimation.js";
        document.head.appendChild(script);
    }

    function render(item){
        item.setAttribute('data-updated', 'true');
        lottie.loadAnimation({
            container: item,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `https://cdn.jsdelivr.net/npm/ibp-max@latest/animation/${item.getAttribute('ag-canvas-animation')}.json`
        });
    }

    function initialize()
    {
        var items = find();
        if(items.length > 0){
            isRenderReady(function(){
                items.forEach(item => {
                    render(item);                    
                });
            });
        }
    }

    function find(){
        return document.querySelectorAll('[ag-canvas-animation]:not([data-updated])');
    }

    window.agAnimation = {
        refresh:initialize
    };

    initialize();
})();